import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";
import { HttpClient, HttpParams } from "@angular/common/http";
import { AngularFireStorage } from "@angular/fire/storage";
import { FirebaseApi } from "./firebase.api";
import { RecipientService } from "../services/recipient.service";
import { DateService } from "../services/date.service";
import * as firebase from "firebase";
import { Observable } from "rxjs/internal/Observable";
import { User } from "../user/user.model";
import { map } from "rxjs/operators";
import { Product } from "../product/product.model";
import { Order } from "../order/order.model";
import { EmailRecipient } from "../email/email.model";
import { EmailRecipientBuilder } from "../email/email.builder";
import { environment } from "src/environments/environment";

//THIS SERVICE ONLY BUILDS THE OBJECTS AND RETURNS THEIR OBSERVABLES. DO NOT STORE THE OBJECTS THEMSELVES IN HERE. STORE THEM IN APP SERVICE
@Injectable({
  providedIn: "root"
})
export class FirebaseService {
  public api: FirebaseApi;
  public recipients: RecipientService;

  constructor(
    public db: AngularFirestore,
    public httpClient: HttpClient,
    public storage: AngularFireStorage,
    public date: DateService
  ) {
    this.api = new FirebaseApi(this.db, this.httpClient);
  }

  get emails$(): Observable<EmailRecipient[]> {
    return this.db
      .collection(environment.recipients)
      .snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(action => {
            var data = action.payload.doc.data();
            var ref = action.payload.doc.ref;
            return new EmailRecipientBuilder().load(data, ref).build();
          });
        })
      );
  }

  get orders$(): Observable<Order[]> {
    return this.api.order.getAll();
  }

  initRecipients = () =>
    (this.recipients = new RecipientService(this.db, this.httpClient));

  public async saveImage(file, directory: string): Promise<string> {
    const id = Math.random()
      .toString(36)
      .substring(2);

    return this.storage.upload(directory + id, file).then(() => {
      return this.storage
        .ref(directory + id)
        .getDownloadURL()
        .toPromise<string>();
    });
  }

  public async sendPushNotificationRequest(message: {}): Promise<void> {
    await this.db.collection("PushNotificationRequests").add(message);
    return;
  }

  async getGeopoint(
    city: string,
    state: string
  ): Promise<firebase.firestore.GeoPoint> {
    const params = new HttpParams()
      .set("address", city + ", " + state)
      .set("key", "AIzaSyDm4ZmSplQOgm3dGnkuP5S913i6tIdKQnI");

    var result: JSON = await this.httpClient
      .get<JSON>("https://maps.googleapis.com/maps/api/geocode/json?", {
        params
      })
      .toPromise();
    if (
      result["status"] == "ZERO_RESULTS" ||
      !result["results"]["0"]["formatted_address"].includes(`${city}, ${state}`)
    )
      return null;

    return new firebase.firestore.GeoPoint(
      result["results"]["0"]["geometry"]["location"]["lat"],
      result["results"]["0"]["geometry"]["location"]["lng"]
    );
  }

  async getTimezone(pt: firebase.firestore.GeoPoint): Promise<string> {
    const params = new HttpParams()
      .set("location", pt.latitude + "," + pt.longitude)
      .set("timestamp", firebase.firestore.Timestamp.now().seconds.toString())
      .set("key", "AIzaSyDml6F7u5BRtyAfeTQiJHKWacepzB01-ss");
    var result = await this.httpClient
      .get<JSON>("https://maps.googleapis.com/maps/api/timezone/json?", {
        params
      })
      .toPromise();
    return result["timeZoneId"];
  }
}
